/**
 * The small muted second line under a title, with the clamp built in.
 *
 * One line, always. A subline that wraps to three is a description, and a
 * description belongs in `CresultcardProse` where a reader can choose to open
 * it.
 */
"use client";
import type { ReactElement, ReactNode } from "react";
import {
  CRC_SUBLINE_SIZE,
  CRC_TEXT_MUTED,
  CRC_TRUNCATE_STYLE,
  CRC_TYPE_STYLE,
} from "./cresultcard.tokens";
import { CresultcardSublineSize, CresultcardTextStep } from "./cresultcard.types";

interface CresultcardSublineProps {
  readonly children: ReactNode;
  readonly size?: CresultcardSublineSize;
}

export function CresultcardSubline({
  children,
  size = CresultcardSublineSize.Regular,
}: CresultcardSublineProps): ReactElement {
  return (
    <span
      data-el="Cresultcard/Subline/Root"
      style={{
        ...CRC_TYPE_STYLE[CresultcardTextStep.Meta],
        ...CRC_TRUNCATE_STYLE,
        display: "block",
        fontSize: CRC_SUBLINE_SIZE[size],
        color: CRC_TEXT_MUTED,
      }}
    >
      {children}
    </span>
  );
}
